$(document).on('click', '[ping]', function sendMixerPing() {
  const tapUrl = $(this).attr('ping');

  if (navigator && navigator.sendBeacon) {
    navigator.sendBeacon(tapUrl);
  } else {
    $.ajax({
      type: 'GET',
      timeout: 1000,
      url: tapUrl,
    });
  }
});
